// pages/ReportsLanding.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ReportsLandingPage.css';

export default function ReportsLandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('reports_landing_seen')) {
      navigate('/reports/list', { replace: true });
    }
  }, [navigate]);

  const handleStart = () => {
    sessionStorage.setItem('reports_landing_seen', '1');
    navigate('/reports/list');
  };

  return (
    <div className="page-content">
      <div className="page-header-container">
        <h1>Отчет по планированию спроса</h1>
      </div>
      <div className="report-landing-container">
          <img 
            loading="eager" 
            fetchPriority ="high"
            width="520"
            height="???" 
            style={{
              borderRadius: "35px",
              maxWidth: "100%",
              height: "auto"
            }} 
            alt="Demand Planning Report" 
            src="/dp-report-landing-hero.webp"
          />
          <p className="report-landing-text">Для сформирования отчета нажмите на кнопку “Начать”</p>
          <button className="primary-button" onClick={handleStart}>Let&apos;s Go</button>
      </div>
    </div>
  );
}